import {SyncUIActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/SyncUIActDecorator';
import {SlotSettings} from '@gongxigames/framework/slot';

export class AutoplayEnableSpinAutoModeUIAct extends SyncUIActDecorator {
    public execute(): void {
        (this.settings as SlotSettings).set('autoplayMode', true);
        this.emitter.emit('UI.enableSpinAutoMode');

        this.onExecuted?.();
    }

    getName(): string {
        return 'AutoplayEnableSpinAutoModeUIAct';
    }
}